<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <h1 class="capitalize">{{ procurement.name }}</h1>

    <template #bottom>
      <div class="px-4 pb-6">
        <div class="flex flex-col w-full mb-5">
          <h3 class="uppercase text-sm mb-2">Items:</h3>

          <bdg-simple-list :items="procurement.items.map(i => i.name)" />
        </div>

        <p class="font-bold">{{ procurement.vendor }}</p>
        <p class="uppercase font-light text-sm">
          <i :class="procurement.typeIconIdentifier" /> {{ procurement.type }}
        </p>
        <div class="dates text-sm mt-2">
          <p>Order Date: {{ procurement.orderDate }}</p>
          <p>Delivery Date: {{ procurement.deliveryDate }}</p>
        </div>

        <div class="purchase-order text-sm mt-2">
          <p>PO#: {{ procurement.id }}</p>
        </div>
      </div>
    </template>
  </list-view-cell>
</template>

<script>
import { ContextMenuItem } from "../../../../helper-classes/ContextMenuItem";
import ListViewCell from "../ListViewCell";
import BdgSimpleList from "../../../simple-list/BdgSimpleList";
import ProcurementForm from "../../../../views/contracts/forms/ProcurementForm";

export default {
  name: "ProcurementCell",
  components: { BdgSimpleList, ListViewCell },
  props: {
    procurement: Object
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ProcurementForm,
            createEditComponentData: this.procurement,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: undefined,
            bodyComponentData: this.procurement,
            isShown: true
          });
        })
      ]
    };
  }
};
</script>

<style scoped></style>
